import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIToggle from 'UIComponents/input/UIToggle';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActivationToggle = ({
  hasWorkflowsAppAccess,
  isFlowEnabled,
  onChange
}) => {
  const noWorkflowAppAccessAndWorkflowIsOn = !hasWorkflowsAppAccess && isFlowEnabled;
  return /*#__PURE__*/_jsxs(TFlex, {
    borderBlockEndColor: "border-primary-subtle",
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    paddingBlock: "200",
    paddingInline: "600",
    align: "center",
    justify: "between",
    children: [/*#__PURE__*/_jsxs(UIFormLabel, {
      htmlFor: "embed-toggle",
      children: [isFlowEnabled && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UIStatusDot, {
          use: "success"
        }), /*#__PURE__*/_jsx(Small, {
          color: "text-tertiary-default",
          weight: "regular",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.embed.flowCanvasContainer.workflowStatus.isOn"
          })
        })]
      }), !isFlowEnabled && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UIStatusDot, {
          use: "default"
        }), /*#__PURE__*/_jsx(Small, {
          color: "text-tertiary-default",
          weight: "regular",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.embed.flowCanvasContainer.workflowStatus.isOff"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(UITooltip, {
      disabled: noWorkflowAppAccessAndWorkflowIsOn,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.embed.flowCanvasContainer.workflowStatus.reviewTooltip"
      }),
      children: /*#__PURE__*/_jsx(UIToggle, {
        checked: isFlowEnabled,
        id: "embed-toggle",
        onChange: onChange,
        size: "xs"
      })
    })]
  });
};
export default ActivationToggle;